import { gql } from "@apollo/client";

export const MANAGE_STATUS = gql`
  mutation setOnlineStatus($isOnline: Boolean!) {
    setOnlineStatus(isOnline: $isOnline) {
      id
    }
  }
`;
